/* eslint-disable no-console */

import { register } from 'register-service-worker'

// Cada cuánto le pedimos al navegador que busque una nueva versión del
// service worker. Necesario porque, en una SPA, el navegador solo revisa
// si hay actualización al recargar la página por completo; sin esto, una
// pestaña abierta por horas nunca se entera de un nuevo despliegue.
const UPDATE_CHECK_INTERVAL = 5 * 60 * 1000 // 5 minutos

// Una vez que el navegador detecta una versión nueva, register-service-worker
// solo dispara updated() una vez. Guardamos el estado para poder volver a
// notificar a la UI en cada chequeo posterior (por si el usuario cerró el
// aviso y queremos que reaparezca en la próxima revisión).
let updatePending = false

// OJO: este camino hoy casi nunca se dispara. El navegador sólo emite `updated`
// cuando el /service-worker.js descargado difiere byte a byte del instalado, y
// desde que index.html y el js/css hasheado quedaron fuera del precache (ver
// `exclude` en vue.config.js) el archivo generado es idéntico entre despliegues.
// El aviso real lo produce src/utils/versionCheck.js; esto se mantiene como
// señal complementaria y emite el MISMO evento.
const notifyUpdateAvailable = () => {
    window.dispatchEvent(new CustomEvent('appUpdateAvailable'))
}

if (process.env.NODE_ENV != 'development') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            console.log(
                'App is being served from cache by a service worker.\n' +
                'For more details, visit https://goo.gl/AFskqB'
            )
        },
        registered(registration) {
            console.log('Service worker has been registered.')

            // registration.update() rechaza si la red falla o el script no
            // está disponible momentáneamente (p. ej. durante un despliegue).
            // Es esperable y se reintenta en el próximo ciclo, no es un error
            // que valga la pena reportar a Sentry.
            const checkForUpdate = () => {
                registration.update().catch(() => {})
                if (updatePending) notifyUpdateAvailable()
            }

            setInterval(checkForUpdate, UPDATE_CHECK_INTERVAL)

            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') checkForUpdate()
            })
        },
        cached() {
            console.log('Content has been cached for offline use.')
        },
        updatefound() {
            console.log('New content is downloading.')
        },
        updated() {
            console.log('New content is available; please refresh.')
            updatePending = true
            notifyUpdateAvailable()
        },
        offline() {
            console.log('No internet connection found. App is running in offline mode.')
        },
        error(error) {
            console.error('Error during service worker registration:', error)
        }
    })
}
